import { createContext, useContext, useState } from 'react';

const currentDate = new Date();
// Add 1 day to the current date
currentDate.setDate(currentDate.getDate() + 1);
const year = currentDate.getFullYear();
const month = String(currentDate.getMonth() + 1).padStart(2, '0');
const day = String(currentDate.getDate()).padStart(2, '0');
const fromDate = `01-${month}-${year}`;
const formattedDate = `${day}-${month}-${year}`;
const range = {
  fromDate,
  toDate: formattedDate,
};

const defaultFilter = {
  type: '',
  date: range,
  template: '',
  status: '',
  eventCount: 0,
  number: ''
};

const defaultSetFilter = () => {
  console.warn('useFilter called outside FilterProvider');
};

const FilterContext = createContext({
  filter: defaultFilter,
  setFilter: defaultSetFilter,
});

export function FilterProvider({ children }) {
  const [filter, setFilterState] = useState(defaultFilter);

  // Wrapper function that merges updates with existing filter state
  const setFilter = (newFilter) => {
    setFilterState((prevFilter) => ({
      ...prevFilter,
      ...newFilter,
    }));
  };

  return <FilterContext.Provider value={{ filter, setFilter }}>{children}</FilterContext.Provider>;
}

export function useFilter() {
  const context = useContext(FilterContext);
  if (!context) {
    console.warn('useFilter must be used within FilterProvider');
    return { filter: defaultFilter, setFilter: defaultSetFilter };
  }
  return context;
}
